import Vue from 'vue'
import Vuex from 'vuex'
import ContentfulVue from 'contentful-vue'

Vue.use(Vuex)
Vue.use(ContentfulVue, {
  space: 'k2z0yol3ki4m',
  accessToken: 'WiebAe9c8ObSMl8xUcV1YKi-W-EZK_NhNUffGZaMNAk'
})

const store = new Vuex.Store({
  state: {
    currentVideo: 0,
    videoList: [],
    navigation: true,
    homepageVideoEffect: false,
    menuVisibility: false,
    showSuggestedTweetOnHomepage: false,
    filterList: []
  },
  mutations: {
    setCurrentVideo (state, url) {
      let index = -1
      console.log(url)
      state.videoList.find(function (item, i) {
        if (item.videoUrl === url) {
          index = i
        }
      })
      state.currentVideo = index > state.videoList.length || index < 0 ? 0 : index
    },
    setNavigation (state, navigation) {
      state.navigation = navigation
    },
    setHomepageVideoEffect (state, homepageVideoEffect) {
      state.homepageVideoEffect = homepageVideoEffect
    },
    setMenuVisibility (state, menuVisibility) {
      state.menuVisibility = menuVisibility
    },
    setVideoList (state, videoList) {
      state.videoList = videoList
    },
    setFilterList (state, filterList) {
      state.filterList = filterList
    },
    setSuggestedTweetHomepageVisibility (state, suggestedTweetVisibility) {
      state.showSuggestedTweetOnHomepage = suggestedTweetVisibility
    }
  },
  getters: {
    hasVideos (state) {
      return state.videoList && state.videoList.length > 0
    },
    emptyEpisode () {
      return {
        order: -1,
        season: -1,
        videoUrl: '',
        title: '',
        description: '',
        authors: [],
        googlePodcastsUrl: '',
        itunesUrl: '',
        spotifyUrl: '',
        suggestedTweet: '',
        transcript: '',
        tags: []
      }
    }
  }
})

export default store
